import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { Role } from '@common/models';
import { Column, DataTableInput, DataTableOutput, Order, PagedData, Search } from '@core/models/datables';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RoleService {

  private columns: Column[] = [
    {
      data: "id",
      name: "ID",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "name",
      name: "Name",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "createdAt",
      name: "Date",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "status.name",
      name: "Status",
      searchable: true,
      orderable: true,
      search: new Search()
    }
  ];

  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all roles
   */
  getAll(page: number, quantity: number) {
    return this._http.get<PagedData<Role>>(`${environment.commonApiUrl}/api/roles/page/${page}/${quantity}`);
  }

  getAllRoles(page: number, quantity: number, order: Order, searchText: string){
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<Role>>(`${environment.commonApiUrl}/api/roles/index`, input);
  }

  /**
   * Get role by id
   */
  getById(id: number) {
    return this._http.get<Role>(`${environment.commonApiUrl}/api/roles/${id}`);
  }

  addRole(role){
    return this._http.post<Role>(`${environment.commonApiUrl}/api/roles`, role).pipe(
      map((response: any) => response.role as Role),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editRole(role){
    return this._http.put<Role>(`${environment.commonApiUrl}/api/roles/${role.id}`, role).pipe(
      map((response: any) => response.role as Role),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, newStatusCode: string) {
    return this._http.put<Role>(`${environment.commonApiUrl}/api/roles/${id}/${newStatusCode}`,{}).pipe(
      map((response: any) => response.role as Role),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función que crea una entrada para datatable por medio de parametros
   * @param page Indica el número de página
   * @param quantity Indica la cantidad de unidades a solicitar
   * @param order Indica el orden que tendrá la columna
   * @param searchText Indica el texto que se va a filtrar
   * @returns Devuelve una entrada para datatable
   */
  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput{
      let input = new DataTableInput();
      input.start = page * quantity;
      input.length = quantity;
      if (searchText !== ''){
        input.search.regex = true;
        input.search.value = searchText;
      }
      if(order){
        input.order.push(order);
      }
      input.columns = this.columns;
      return input;
  }

}
